/**
 * The customer's own order page (2026-09-28, docs/PRINT-ORDER-FLOW.md) - /order/:orderId?t=<token>.
 * Linked from every order email and their account; no login needed. The content is shared-ui's
 * CustomerOrderView (pay, new artwork, proof, tracking, received, report a problem, order again).
 */
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CustomerOrderView } from 'shared-ui';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getApiBaseUrl } from '../services/api';

export default function CustomerOrderPage() {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('t') || '';

  return (
    <>
      <Header />
      <main style={{ marginTop: '80px', minHeight: '70vh' }}>
        {token ? (
          <CustomerOrderView
            apiBaseUrl={getApiBaseUrl()}
            orderId={orderId}
            token={token}
            returnUrl={typeof window !== 'undefined' ? `${window.location.origin}/order/${orderId}?t=${token}` : undefined}
            onOrderAgain={(order) => navigate(`/print-order?repeat=${order.id}&t=${encodeURIComponent(token)}`)}
          />
        ) : (
          <div style={{ padding: 40, textAlign: 'center' }}>This order link is missing its code - open it from your email or your account.</div>
        )}
      </main>
      <Footer />
    </>
  );
}
